import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface StoragePieChartProps {
  photosStorage: number;
  othersStorage: number;
  totalStorage: number;
}

export const StoragePieChart: FC<StoragePieChartProps> = ({
  photosStorage,
  othersStorage,
  totalStorage
}) => {
  const { t } = useTranslation();

  // Calculate percentages
  const photosPercentage = (photosStorage / totalStorage) * 100;

  // Calculate pie chart angles
  const photosAngle = (photosPercentage / 100) * 360;

  return (
    <div className="flex flex-row gap-[61px]">
      {/* Pie Chart */}
      <div className="relative flex flex-col gap-2.5 p-[99px] w-[259px] h-[248.87px]">
        {/* SVG Pie Chart */}
        <svg
          className="absolute top-0 left-0"
          width="259"
          height="249"
          viewBox="0 0 259 249"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          {/* Others segment */}
          <circle cx="129.5" cy="124.5" r="124.5" fill="#5D6063" />

          {/* Photos segment */}
          <path
            d={`M 129.5 124.5 L 254 124.5 A 124.5 124.5 0 ${
              photosAngle > 180 ? 1 : 0
            } 1 ${129.5 + 124.5 * Math.cos(((photosAngle - 90) * Math.PI) / 180)}
            ${
              124.5 + 124.5 * Math.sin(((photosAngle - 90) * Math.PI) / 180)
            } Z`}
            fill="#7D43F5"
          />
        </svg>

        {/* Center Text */}
        <div className="relative z-10 flex flex-col w-[59px] mx-auto">
          <p className="text-xl font-bold text-black">
            {photosStorage + othersStorage} {t('storageChart.gb')}
          </p>
          <p className="text-sm font-medium text-black">
            {t('storageChart.used')}
          </p>
        </div>
      </div>

      {/* Legend */}
      <div className="flex flex-col gap-3 w-[156px]">
        {/* Photos */}
        <div className="flex flex-row items-end self-stretch gap-2.5">
          <div className="w-3 h-3 bg-[#7D43F5] rounded-full" />
          <p className="text-xs font-semibold text-black">
            {t('storageChart.photos')}: {photosStorage}{' '}
            {t('storageChart.usedGb')}
          </p>
        </div>

        {/* Others */}
        <div className="flex flex-row items-end self-stretch gap-2.5">
          <div className="w-3 h-3 bg-[#5D6063] rounded-full" />
          <p className="text-xs font-semibold text-black">
            {t('storageChart.others')}: {othersStorage}{' '}
            {t('storageChart.usedGb')}
          </p>
        </div>
      </div>
    </div>
  );
};
